import { isRouteErrorResponse, useRouteError, Link } from 'react-router-dom';
import { PATHS } from '@shared/router/paths';
import { logger } from '@shared/utils/logger';

/**
 * Route-level error element registered on the root route. Catches render and
 * loader errors in the routed subtree and presents a recoverable fallback
 * instead of a blank screen.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();
  logger.error('Route error', error);

  const title = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : 'Something went wrong';
  const message = isRouteErrorResponse(error)
    ? (error.data as string) || 'The page could not be loaded.'
    : 'An unexpected error occurred while rendering this page.';

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <h1 className="text-2xl font-semibold text-foreground">{title}</h1>
      <p className="max-w-md text-sm text-muted-foreground">{message}</p>
      <Link
        to={PATHS.root}
        className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:opacity-90"
      >
        Back to safety
      </Link>
    </div>
  );
}
